import { UiStrings } from "./UiStrings";

export const UiStringsRu: UiStrings = {
  common: {
    dismiss: 'Отменить',
    close: 'Закрыть',
    continue: 'Продолжить',
    back: 'Назад',
    xp: 'XP',
    explain: 'Объяснить',
    and: 'и',
    or: 'или',
    secShort: 'с',
    minShort: 'мин',
    saveChanges: 'Сохранить изменения',
    logout: 'Выйти из сессии',
    ago: 'назад',
    yes: 'Да',
    no: 'Нет',
    translate: 'Перевести',
    saveTerm: 'В словарь',
    tryAgain: 'Попробовать снова',
    pleaseWait: 'Пожалуйста, подождите...',
    checkAgainLater: 'Проверьте позже',
    errors: {
      tooManyRequests: "Вы использовали это слишком много раз, пожалуйста, попробуйте снова позже.",
    }
  },
  nav: {
    header: {
      tabs: {
        workbook: 'Тетрадь',
        contacts: 'Контакты',
        feed: 'Для Тебя',
        recent: 'Недавние',
        games: 'Игры',
      }
    },
    bottomBar: {
      home: 'Главная',
      contacts: 'Контакты',
      feed: 'Лента',
      inbox: 'Задания',
      vocab: 'Словарь',
    }
  },
  tryit: {
    existingUsersLogin: 'Вход для пользователей',
  },
  login: {
    title: 'Вход',
    welcome: 'Добро пожаловать в приложение',
    requestCodeButton: 'Запросить код для входа:',
    requestCodeInfo: 'Используйте Telegram или email для запроса кода для входа, который вы должны ввести здесь.',
    codeInputLabel: 'Введите код, который вы получили:',
    verifyCodeButton: 'Проверить код',
    verifying: 'Проверка...',
    codeInputPlaceholder: 'Код из Telegram',
    codeEmailInputPlaceholder: 'Код из письма',
    codeInputError: 'Неверный код',
    codeInputSuccess: 'Код проверен успешно',
    cancel: 'Отменить',
    emailInputLabel: 'Адрес электронной почты',
    emailInputPlaceholder: 'Введите ваш email',
    sendCodeButton: 'Отправить код',
    sendingCode: 'Отправка...',
    checkEmail: 'Проверьте вашу электронную почту для получения кода аутентификации',
    codeExpiresIn: 'Код истекает через',
    resendCode: 'Отправить код повторно',
    selectNativeLanguage: 'Выберите ваш родной язык',
  },
  landing: {
    demoChat: {
      tagline: 'Языковая практика с ИИ и голосом 🎤👂💥',
      correction: 'Исправление',
      responseOptions: 'Варианты ответов',
    },
    testimonials: {
      title: 'Нас хвалят пользователи ☺️',
    },
    learningMotivation: {
      title: 'Помогает в разных ситуациях',
    },
    voiceExamples: {
      title: "Как живые!",
      detail: "Практикуйтесь с нашими ИИ репетиторами, используя естественные, человеческие голоса для погружения в любой язык.",
      listen: "Слушать",
      pause: "Пауза",
      playing: "⏸️",
      info: {
        title: "Говорите естественно с ИИ репетиторами, которые звучат как люди",
        chip1: "Гибкие темы",
        chip2: "Инструменты обучения",
        chip3: "Подробные отзывы",
        chip4: "Естественные голоса",
      },
      leadOut: "Наши ИИ репетиторы используют премиальные голосовые модели, которые звучат естественно и отвечают вам в реальном времени."
    },
    betterWithTelegram: {
      title: "Лучше с Telegram",
      info: "Наш бот интегрирован с Telegram и может интеллектуально отвечать на ваши сообщения и помогать с практикой и подготовкой к экзаменаму.",
      info2: "Бот Chatlanga станет надежным партнером по практике для ваших грамматических и речевых навыков.",
    },
    videoCarousel: {
      practiceStart: "Выбирайте из разных тем, игр или используйте свои идеи 💡",
      fluencyMeter: "Отслеживайте беглость разговора в реальном времени ⏱️",
      tapTranslations: "Неизвестные слова? Переведите любое сообщение, нажав на него 🌐",
      responseOptions: "Практика без стресса с предложениями ответов от ИИ 😌",
    },
    knowledgeBase: {  
      title: 'Учебные материалы',
      info: 'Для некоторых языков Chatlanga предлагает учебные материалы, адаптированные для носителей разных культур.',
      info2: 'Наша растущая база знаний состоит из статей, тестов и упражнений по аудированию на разных темах и грамматических аспектах языка.',
    }
  },
  dashboard: {
    progress: {
      title: 'Прогресс',
      description: 'Отслеживайте свой прогресс в изучении языка',
      currentRank: 'Уровень',
      nextRank: 'Следующий',
      practicesTaken: 'Практик пройдено',
      examsTaken: 'Экзаменов пройдено',
      wordsLearned: 'Слов выучено',
      vocabSize: 'Размер словаря',      
    },
    practice: {
      title: 'Голосовой звонок',
      description: 'Практикуйте свой язык с нашими практическими сессиями',
    },
    chatPractice: {
      title: 'Голосовой чат',
      description: 'Практикуйте свой язык с нашими голосовыми сессиями',
    },
    exam: {
      title: 'Симуляция экзамена',
      description: 'Пройдите свой языковой экзамен с нашей симуляцией экзамена',
      notAvailable: 'Экзамен в разработке, запуск в ближайшие недели!',
    },
    corrections: {
      title: 'Недавние ошибки',
      description: 'Просмотрите свои недавние ошибки',
      noMistakes: 'Ошибки устранены! Продолжайте в том же духе!',
      noSessions: 'Попробуйте свою первую практическую сессию, чтобы улучшить свои языковые навыки!',
      dismissing: 'Прячем ошибку...',
      originalPhrase: 'Исходная фраза',
      correction: 'Исправление',
      comment: 'Заметка',
      showMore: 'Показать все',
      showLess: 'Показать меньше',
    },
    vocabulary: {
      title: 'Новые слова',
      description: 'Слова из последних сессий практики',
      buttonLearn: 'Выучено',
      buttonDismiss: 'Спрятать',
      originalPhrase: 'Исходная фраза',
      updating: 'Обновление словаря...',
    },
    recentConversations: {
      title: 'Последние разговоры',      
      noSessions: 'У вас пока не было сессий. Попробуйте практику!',            
    },
    chatExercises: {
      title: 'Упражнения в чате',
      info: 'Получите случайное упражнение от нашего ИИ репетитора в вашем Telegram',
      send: 'Выслать',
      more: 'Еще',
    },
    articles: {
      title: 'Учебные материалы',
    },
    rewards: {
      title: 'Призы',
      noRewards: 'Пока нет ни одного приза',
    },
  },
  creditsInfo: {
    credits: 'кредиты',    
    one_credit: 'кредит',
    many_credits: 'кредиты',
    inflectCredits: function(count: number, form: 'nominative' | 'genitive' | 'dative' | 'accusative' | 'instrumental' | 'prepositional') {
      if (form === 'genitive') {
        const lastDigit = count % 10;
        if (lastDigit === 1) {
          return `кредита`;
        } else if (lastDigit >= 2 && lastDigit <= 4) {
          return `кредита`;
        } else {
          return `кредитов`;
        }
      }
      
      if (count === 1) {
        return `кредит`;
      }
      return `кредиты`;
    },
    buyMoreCredits: 'Пополнить',
  },
  languages: {
    title: 'Настройки языка',
    backToDashboard: 'Назад на старт',
    appLanguage: 'Язык программы',
    selectLanguageLabel: 'Выберите язык, который вы хотите изучить:',
    messages: {
      levelNotAvailable: 'Уровень не доступен',
      levelNotAvailableDescription: '⏳ Репетитор для данного уровня еще не доступен. Он будет доступен в течение ближайших нескольких недель!',
    }
  },
  examDetails: {
    spanish: {
      oral: {
        beginner: {
          instructions: 'Вам выдают тему монолога и диалога. У вас будет 10 минут, чтобы подготовиться к монологу и диалогу. После этого вам будет показано изображение, которое вам нужно будет описать.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    },
    german: {
      oral: {
        beginner: {
          instructions: 'Вам выдают тему монолога и диалога. У вас будет 10 минут, чтобы подготовиться к монологу и диалогу. После этого вам будет показано изображение, которое вам нужно будет описать.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    }
  },
  exam: {
    stages: {
      monologue: 'Монолог',
      dialogue: 'Разговор',
      describing: 'Описание',
    },
    scoreComponents: {
      hollistic: 'Общая оценка',
      corrections: 'Грамматика',
      fluency: 'Беглость',
      reach: 'Достижение',
      coherence: 'Структура',
    },
    completed: {
      sendSummary: 'Отправить отчет',
      overall: {
        title: 'Общая оценка',
      },
      stageScores: {
        title: 'Оценка по этапам',
        max: 'Макс.',
        mean: 'Среднее',
      },
      skills: {
        title: 'Оценка навыков',
        detail: 'Чем дальше от центра, тем лучше - лучшие результаты выглядят как полностью заполненный ромб 🔹',
      },
      observations: {
        title: 'Наблюдения',
        emptyCategory: 'Нет наблюдений в этой категории',
      },
      corrections: {
        title: 'Исправления',
        emptyList: 'Нет исправлений',
      }
    }
  },
  beforeConversation: {
    silencePlease: "Необходима тишина",
    silenceInfo: "Убедитесь, что вы находитесь в тихой комнате и никто не говорит рядом с вами",
  },
  beforeExam: {
    title: 'Симуляция экзамена',
    approximateSimulation: 'Условная симуляция',
    examDurationMinutes: 'мин',
    tutorLabel: 'Экзамен ведет:',
    yourTicket: 'Ваш билет:',
    examStages: {
      monologue: 'Монолог',
      dialogue: 'Разговор',
    },
    welcome: function(firstName: string) {
      return `Привет, ${firstName}!`;
    },
    audioPermissions: {
      title: 'Разрешения на микрофон',
      ensurePermissions: 'Подготовьте микрофон и наушники или колонки:',      
    },
    startExam: "Тянуть билет",
    startFirstStage: "Начать",
  },
  beforePractice: {
    title: 'Практика разговора',
    tutorShortIntro: 'Практику ведет:',
    connectingWith: 'Подключаемся к',
    welcome: function(firstName: string) {
      return `Привет, ${firstName}!`;
    },
    notEnoughCredits: 'Добавить кредиты',
    muteNotice: 'Пожалуйста, убедитесь, что 🔇 => 🔊 звук вкладки браузера активирован.',
    audioPermissions: {
      title: 'Разрешения на микрофон',
      ensurePermissions: 'Подготовьте микрофон и наушники или колонки:',      
    },
    configurePractice: "Подготовка к практике",
    startPractice: "Начать",
    settings: {
      title: 'Настройки практики',
      motherLanguage: 'Ваш родной язык',
      targetLanguage: 'Язык для практики',
      languageLevel: 'Ваш уровень',
      continue: 'Перейти к практике',
      edit: 'Изменить',
    },
    userGoals: {
      default: 'Навык разговора',
      exam: 'Экзамен',
      travelTo: 'Путешествие/переезд',
      jobInterview: 'Собеседование',
      relationship: 'Язык отношений',
      rentApartment: 'Аренда квартиры',
      talkToAccountant: 'Деньги и налоги',
      talkToDoctor: 'У врача',
      escapeRoom: 'Эскейп-рум',
      treasureHunt: 'Поиск сокровищ',
      grammarExercises: 'Грамматика',
      wordGame: 'Игра в слова',
      practiceIntro: 'Первый разговор',
      custom: 'Напишите свою цель',
    }
  },
  userGoalsDialog: {
    title: 'Что вы хотите от практики?',
    subtitle: 'Выберите цель практики, чтобы настроить разговор с педагогом',
    customGoal: 'Ваша цель',
    customGoalPlaceholder: 'e.g. "Поговорить с моими союзниками в Fortnite"',
  },
  audioPermissions: {
    enableMicrophone: 'Включите микрофон и убедитесь что у вашего устройства включен звук',
    clickToFix: 'Нажмите, чтобы исправить',
    microphone: 'Микрофон',
    microphoneNotEnabled: 'Микрофон в данный момент не включен, нажмите кнопку, чтобы включить его:',
  },
  audioDeviceSelector: {
    microphone: 'Микрофон',
    speakers: 'Наушники или колонки:',
    muteNote: '* Вы также можете отключить тихий режим браузера',
  },
  topicSelection: {
    title: 'Select a Topic',
    instructions: "Click the button below to randomly select your speaking topic.\n You'll have 10 minutes to prepare your presentation.",
    button: 'Draw Topic',
    info1: "The exam simulation consists of two parts: 1) your introduction and monologue on a given topic, and 2) a conversation with the examiner, where you'll be asked questions within an imaginary situational context.",
    info2: "You'll have 10 minutes to prepare your presentation, after which the conversation will begin. You can skip the wait and start the conversation earlier, if you want.",
    skipWait: 'Start',
    anotherTopic: 'Another Topic',
    topicDescription: 'Description',
    topicInstructions: 'Instructions',
  },
  examFlow: {
    describeImage: {
      defaultInstruction: "Опишите ситуацию, изображенную здесь",
    }
  },
  rating: {
    title: 'Спасибо за ваше выступление!',
    nextUp: 'Следующий:',
    conversation: 'Оценка навыков разговора',
    continue: 'Продолжить',
  },
  conversationInterface: {
    start: 'Начать',
    abort: 'Завершить',
    continue: 'Продолжить',
    pleaseWait: 'Пожалуйста, подождите...',
    stageNames: {
      intro: 'Введение',
      monologue: 'Монолог',
      dialogue: 'Разговор',
      practice: 'Практика',
    },
    conversationState: {
      ready: 'Готово к началу',
      inProgress: 'Разговор в процессе',
      clickToEnd: 'Нажмите кнопку ниже, чтобы завершить разговор',
      clickToStart: 'Нажмите кнопку ниже, чтобы начать разговор',
    },
    countdown: {
      timeLeft: 'Осталось времени:',
      timeUp: 'Ваше время почти подошло к концу, попрощайтесь с педагогом!',
      timeLeftToPrepare: 'Осталось времени на подготовку:',
    }
  },
  practiceSessionBoard: {
    title: 'Заметки репетитора',
    transcriptionTitle: 'Текст разговора',
    yourTurnToSpeak: 'Ваша очередь говорить',
    mistakesDetected: 'Замечены ошибки',
    vocab: {
      title: 'Новые слова',
      dismissKnown: 'Убрать',
      willBeSent: 'Это будет отправлено вам после сессии',
      emptyList: 'Нет новых слов',
    },
    corrections: {
      title: 'Ошибки',
      dismiss: 'Убрать',
      willBeSent: 'Это будет отправлено вам после сессии',
      emptyList: 'Нет ошибок',
    },
    history: {
      title: 'История разговоров',
      emptyList: 'Пока ничего не сказано',
      you: 'Вы',
      tutor: 'Педагог',
    },
  },
  footer: {
    support: 'Тех. Поддержка',
    checkWebsite: 'Проверьте наш сайт',
    privacyPolicy: 'Политика данных',
    termsOfService: 'Условия сервиса',
    acceptTerms: 'Я принимаю условия сервиса и политику данных',
  },
  profile: {
    referral: {
      title: 'Приглашай и получай',
      description: 'Поделись своей ссылкой на приглашение с друзьями. Когда они зарегистрируются, вы оба получите бонусные кредиты!',
      copied: 'Скопировано!',
      copy: 'Скопировать',
      invitedCount: function(count: number) {
        return `Вы пригласили ${count} друзей!`;
      },
    },
    personal: {
      title: 'Личные данные',
      firstName: 'Имя',
      lastName: 'Фамилия',
      telegramUsername: 'Имя в Telegram',
      notConnected: 'Не подключено',
      telegramLinked: 'Подключено к вашему Telegram',
    },
    notifications: {
      title: 'Уведомления',
      practiceReminders: 'Напоминания о практике через Telegram',
      practiceRemindersDescription: 'Получайте напоминания о практике через наш Telegram-бот',
      reminderFrequency: 'Частота напоминаний',
      frequentDaily: 'Часто (ежедневно)',
      moderateWeekly: 'Средне (2-3 раза в неделю)',
      rareWeekly: 'Редко (еженедельно)',
    },
    chatResponses: 'ИИ-ответа осталось в Telegram',
    deleteAccount: {
      deleteButton: 'Удалить аккаунт',
      deleteButtonInfo: 'Это удалит ваш аккаунт и все ваши данные. Полное удаление небольшой части данных может занять до 6 календарных дней.',
      deleteConfirmation: 'ПОДТВЕРЖДЕНИЕ: Вы уверены, что хотите удалить ваш аккаунт? Это действие не может быть отменено!',
    },
    tutorials: {
      resetButton: 'Сбросить обучающие советы',
      resetButtonInfo: 'Это сбросит все ваши просмотренные советы от Чатланги (обучающиесообщения внизу экрана) и заставит их появиться снова по одному разу.',
      notifications: {
        tutorialsReset: 'Обучающие советы сброшены',
      }
    }
  },
  assessmentLoading: {
    title: 'Оценка в процессе',
    subtitle: 'Пожалуйста, подождите, пока мы обрабатываем ваши результаты...',
    stateComplete: 'Завершено',
    step1Label: 'Сбор транскрипции',
    step2Label: 'Анализ грамматики',
    step3Label: 'Оценка словаря',
    step4Label: 'Обработка семантики',
    step5Label: 'Генерация исправлений',
    step6Label: 'Создание рекомендаций',
  },
  assessmentDetails: {
    title: 'Детали оценки',
    practice: 'Практика',
    monologue: 'Монолог',
    dialogue: 'Разговор',
    grammar: 'Грамматика',
    vocabulary: 'Словарь',
    fluency: 'Беглость',
    fluencyChart: 'Беглость в этом разговоре',
    pronunciation: 'Произношение',
    overall: 'Общая оценка',
    corrections: 'Ошибки',
  },
  practiceCompleted: {
    tryAgainButton: 'Еще раз',
    sendSummaryButton: 'Конспект',
    firstTryIssues: {
      info1: "Мы заметили, что у вас были некоторые проблемы! Это нормально! Если вы не знаете, как сказать что-то – просто спросите репетитора на родном языке.",
      info2: "Нажимайте на сообщения в чате, чтобы перевести их на ваш язык.",
      info3: "Не волнуйтесь! Мы предлагаем вам еще одну практику бесплатно, просто начните новую практическую сессию прямо сейчас:",
      retryButton: "Повторить бесплатно",
    },
    creditsLeft: (credits: number) => `Остается ${credits} ${UiStringsRu.creditsInfo.inflectCredits(credits, 'genitive')}`,
    tryGameModes: "Попробуйте игровые режимы практики:",
    tryWithCreditsInfo: (credits: number, sessionsLeft: number, price: number) => `На ${credits} кредитов вы можете попробовать еще до ${sessionsLeft} раз! В конце каждой сессии списывается ${price} кредитов.`,
  },
  converationAudioIssues: {
    title: "Не обнаружено речи",
    noSpeechDetected: "Мы не смогли обнаружить ваш голос во время практической сессии. Это может быть связано с техническими проблемами с вашим микрофоном.",
    pleaseCheck: "Пожалуйста, проверьте следующее:",
    ensureSilentModeOff: "Убедитесь, что ваше устройство <b>не в тихом режиме</b> и звук включен",
    ensureMicrophoneEnabled: "Убедитесь, что ваш <b>микрофон включен</b> в настройках вашего браузера",    
    checkHeadset: "Убедитесь, что вы используете <b>либо наушники, либо внешние колонки</b>, но не оба",
    ensureTabNotMuted: "Убедитесь, что ваш браузерный вкладка <b>не заглушена</b>",
  },
  onboarding: {
    title: "Личные данные",
    welcome: "Немного о себе",
    continue: "Продолжить",
    welcomeSubtitle: "Начните свой путь к изучению языка",
    welcomeInfo: "Заполните опросник ниже, чтобы персонализировать алгоритм вашего обучения",
    personalInfo: {
      title: "Личные данные",
      firstName: "Имя",
      firstNameInfo: "AI-учителя будут использовать это имя",
      firstNamePlaceholder: "Ваше имя",
      lastName: "Фамилия",
      lastNamePlaceholder: "Ваша фамилия",
    },
    languageInfo: {
      title: "Настройки изучения",
      subtitle: "",
      motherLanguage: "Ваш родной язык",
      motherLanguageInfo: "Это будет использоваться для UI и инструкций",
      targetLanguage: "Язык, который вы изучаете",
      languageLevel: "Ваш текущий уровень",
    },
    learningMotivation: {
      title: "Мотивация изучения",
      subtitle: "Почему вы решили изучать этот язык?",
      options: {
        relocation: "Переезд",
        exam: "Экзамен",
        travel: "Путешествие",
        relationship: "Отношения",
        career: "Карьера",
        family: "Семья",
        other: "Что-то еще!",
      },
    },
    learningGoals: {
      title: "Цели изучения",
      subtitle: "Какие цели вы ставите перед собой?",
      options: {
        fluency: "Навык разговора",
        vocab: "Больше слов",
        idioms: "Идиомы",
        anxiety: "Страх выступлений",
        job: "Найти работу",
        other: "Что-то еще!",
      },
    },
    learningSchedule: {
      title: "Расписание изучения",
      subtitle: "<b>Совет:</b> Chatlanga помогает лучше, если вы практикуетесь немного (хотя бы 5 минут), но почти каждый день!",
      question: "Как часто вы планируете практиковаться?",
      options: {
        few_times_per_day: "Несколько раз в день",
        once_per_day: "Один раз в день",
        few_times_per_few_days: "Пару раз за 2-3 дня",
        idk: "Я не знаю",
        other: "Что-то еще!",
      }
    },
    termsOfService: {
      title: "Правовая информация",
      termsOfService: "Условия сервиса",
      privacyPolicy: "Политика данных",
      acceptTerms: "Я принимаю условия сервиса и политику данных",
      confirmAge: 'Я старше 16 лет',
      confirmAgeInfo: 'Некоторые страны требуют, чтобы чаты с ИИ были ограничены для лиц младше 16 лет.',
    },
    completeSetup: "Начать учиться",
  },
  examStatus: {
    title: 'Спасибо за прохождение симуляции экзамена!',
    postExamInfo: "Ваш языковой экзамен прошел успешно. \nМы надеемся, что этот опыт оказался полезным для улучшения ваших навыков разговора.",
    quickAssessment: {
      pleaseWait: 'Пожалуйста, подождите, пока мы обрабатываем ваши результаты...',
      title: 'Quick Assessment',
      monologue: 'Monologue Assessment',
      dialogue: 'Dialogue Assessment',
      grammar: 'Grammar',
      vocabulary: 'Vocabulary',
      fluency: 'Fluency',
      totalScore: 'Total Score',
      feedback: 'Feedback:',
    },
    recordings: {
      title: 'Your Recordings',
      monologue: 'Monologue Recording',
      dialogue: 'Dialogue Recording',
      pleaseWait: 'The recording is being created...',
    },
    thankYou: {
      title: 'Thank you for completing our exam simulation!',
      reloadLater: "You can switch to another tab but do not close this one. Reload it later to get the teacher's full assessment.",
    }
  },
  practiceResponseOptions: {
    title: 'Идеи для ответа',
    disabledTitle: 'Подсказки',
    dismiss: 'Отменить',
    loading: 'Загрузка...',
    noOptions: 'Нет предложений',
    tutorSaid: 'Педагог:',
    enable: 'Вкл',
    disable: 'Выкл',
  },
  balance: {
    buyMoreCredits: 'Пополнение кредитов',
    startCheckout: 'Оплатить',
    thanks: 'Спасибо за покупку!',
    purchaseSuccessful: 'Успешно оплачено',
    aboutCredits: {
      title: 'Как использовать кредиты?',
      details: 'Кредиты используются для покупки AI-базируемых услуг в приложении Chatlanga. Наши высококачественные модели и синтез речи требуют серьезных усилий в виде GPU 💪 и мы работаем над их стабильной работой.',
      services: {
        practice: {
          title: 'Практика речи',
          detail: '5-мин практическая сессия с премиальным AI-агентом',
        },
        exam: {
          title: 'Симуляция экзамена',
          detail: 'Симуляция экзамена с тремя частями: монолог, диалог и описание',
        },
        chatPackStandard: {
          title: 'Базовый пакет ответов',
          detail: '50 умных ответов от нашего ИИ репетитора в Telegram',
        },
        chatPackPremium: {
          title: 'Премиум пакет ответов',
          detail: '200 умных ответов от нашего ИИ репетитора в Telegram',
        }
      }
    }
  },
  coupons: {
    couponForm: {
      title: 'Активация купона',
      codeLabel: 'Код купона...',
      codePlaceholder: 'Код купона...',
      submitButton: 'Применить',
    },
    modal: {
      title: 'Купон активирован!',
      detail: 'Ваш купонный код успешно применен.',
      defaultMessage: 'Кредиты добавлены на ваш счет.',
    },
    errors: {
      notFound: 'Купон не найден',
      alreadyClaimed: 'Купон уже использован',
      failedToClaim: 'Не удалось использовать купон',            
    }
  },
  support: {    
    tabs: {
      articles: 'Помощь',
      myTickets: 'Мои запросы',
    },
    articles: {
      title: 'Частые вопросы',
      botChatInfo: 'Свяжитесь с нами в Telegram, чтобы задать вопрос, предложить идею или сообщить об ошибке. В канале поддержки Chatlanga на вопросы отвечают люди, а не ИИ.',
      telegramSupport: 'Задайте нам вопрос в Telegram',
    },
    ticketForm: {
      title: 'Отправить запрос',
      email: 'Email',
      emailPlaceholder: 'Ваш email...',
      topic: 'Тема',
      topicPlaceholder: 'Проблема или предложение...',
      type: 'Тип запроса',
      typePlaceholder: 'Выберите тип запроса',
      requestType: {
        bug: 'Ошибка',
        suggestion: 'Предложение',
        featureRequest: 'Запрос функции',
        other: 'Другое',
      },
      message: 'Сообщение',
      messagePlaceholder: 'Опишите вашу проблему или предложение...',
      submitButton: 'Отправить',
      submitted: 'Запрос отправлен успешно!',
    },
    myTickets: {
      title: 'Мои запросы',
      createTicket: 'Создать запрос',
      noTickets: 'Если вы хотите получить помощь, нажмите на кнопку ниже, чтобы создать новый запрос поддержки:',
      createTicketButton: 'Создать запрос',
      ticketList: {
        open: 'Открыт',
        inProgress: 'В процессе',
        closed: 'Закрыт',
      },
    }
  },
  pushToTalk: {
    defaultLabel: 'Зажмите и говорите',
    recording: 'Отпустите для отправки',
    processing: 'Подождите...',
    speakNow: 'Говорите...',
  },
  soundTest: {
    title: "Тест звука",
    instructionPrefix: "Скажите:",
    testPhrase: "Я уже готов начать",
    confirmationQuery: "Вы слышали ответ?",
    successMessage: "Тест звука завершен успешно!",
    micError: "Убедитесь, что у вас есть разрешение на использование микрофона и проверьте, подключены ли какие-либо дополнительные устройства Bluetooth",
    tabMutedError: "🔇 => 🔊 Проверьте, не заблокирован ли ваш браузер!",
  }, 
  chatSpeechMeter: {
    info: function(wpm: number, minWpm: number, maxWpm: number, levelName: string) {
      return `Ваша беглость: ≈${wpm} слов в минуту. Ожидаемый диапазон для уровня ${levelName} составляет ${minWpm} - ${maxWpm} слов в минуту.`;
    }
  },
  voiceChat: {
    chatFlow: {
      title: "Голосовой чат",
      playbackRate: "Текущая скорость голоса",
      messagePlaceholder: "Напишите ваше сообщение...",
      hints: {
        pushToTalk: "Зажмите или нажмите для записи голоса, нажмите еще раз или отпустите для отправки",
        emotions: "Выберите выражение лица для сообщения",
      },
      history: {
        assist: "Подсказки",
        notes: "Заметки",
      },
      limitNoice: {
        title: "Дневной лимит достигнут",
        detail: "⏳ Вы достигли дневного лимита для отправки сообщений. Пожалуйста, дождитесь полуночи, чтобы лимиты обновились.",
      }
    },
    inventory: {
      manager: {
        title: "Ваши предметы",
      },
      itemDetails: {
        acquiredInMessage: "Получено в контексте:",
        emptyList: "Предметы, которые могут быть использованы в чате или которые вы получаете во время чата, будут отображаться здесь.",
        itemReceived: "Предмет получен",
        itemLost: "Предмет отдан",
      },
    },
    panels: {
      wordCounter: {
        title: "Слов",
      },
      progress: {
        title: "Прогресс",
      },
      lives: {
        title: "Жизни",
      },
    },
  },
  todoLists: {
    dashboardTitle: "Ваши задания",
    currentTask: "Задание:",
    item: {
      status: {
        completed: "Выполнено",
      }
    },
    drawer: {
      defaultLabel: "Учебное задание",
      loading: "Пожалуйста, подождите, пока репетитор подготовит текст заметки...",
    },
    modals: {
      taskCompleted: {
        title: "Задание выполнено",
        continueLearning: "Продолжить обучение",
      },
      taskCreated: {
        title: "Новое задание",
      },
      rewardReceived: {
        title: "Новый приз!",
      },
    }
  },
  imageOverlay: {
    zoomTip: "Поддерживается увеличение и перетаскиваение",
  },
  feed: {
    miniChallengeButton: "Проверь себя",
    loader: {
      title: "Загрузка новых постов",
      subtitle: "Подготовка персонализированного контента для вас",
    },
    waitToLoadMore: {
      title: "Сначала просмотрите текущие посты!",
      subtitle: "Почитайте посты в ленте еще немного перед загрузкой новых публикаций 😅",
    },
    addingContact: {
      title: "Добавление контакта",
      subtitle: "У вас появился новый виртуальный контакт!",
    },
    giftBox: {
      openMode: {
        hits: {
          title1: "Тапайте пока не откроется!",
          title2: "Сюрприз внутри!",
          title3: "Случайный приз ждет!",
        }
      },
      note: "В подарках находятся новые контакты, полезные предметы и другие награды!",
    }
  },
  quizForm: {
    correct: "Правильно: ",
    correctCount: "Правильно: ",
    incorrectCount: "Ошибки: ",
    quizCompleted: "Тест завершен",
    quizCompletedDetail: "Вы завершили тест. Вы можете попробовать еще раз, чтобы получить более высокие оценки.",
    repeatQuiz: "Попробовать снова",
  },
  contacts: {
    newContactsNote: 'Получайте новые контакты, находя новые контакты в "Для тебя"! Читайте статьи и решайте квизы, чтобы открыть новые 🎁 подарки!',
    contactTasks: 'Задания:',
    startTaskChat: 'Начать задание',
  },
  experienceBar: {
    gameLivesHint: 'Ваши игровые жизни',
    rankHint: 'Ваш уровень ученика',
    xpLeftToNextLevel: 'XP до следующего уровня',
    xpGained: 'Получен опыт'
  },
  vocabularyPage: {
    vocabListTitle: 'Ваш словарь',
    shortTitle: 'Список слов',
    emptyList: 'Словарь пуст. Используйте кнопку "Сохранить" в объяснениях слов, чтобы добавить слова в ваш словарь.',
    wordGameButton: 'КУБ слов',
  },
  wordGame: {
    cube: {
      title: 'Flash cube',
      questionLabel: 'Вопрос',
      translationLabel: 'Переведите:',
      instruction: 'Вращайте куб пальцем или мышкой, чтобы увидеть все варианты ответа.',
      otherDefinitions: 'Другие значения:',
      wordForIncorrectAnswer: 'Неверное слово',
    },
    completeModal: {
      title: 'Игра завершена!',
      effort: {
        veryLow: 'Ой! 😭',
        low: 'Надо практиковаться 📚',
        medium: 'Хорошая работа 💪',
        high: 'Очень хорошо 🎉',
        veryHigh: 'Идеально 🌟',
      }
    }
  }
};
